import { render } from "./TrainingRunHost.vue?vue&type=template&id=552f3cc8"
import script from "./TrainingRunHost.vue?vue&type=script&lang=js"
export * from "./TrainingRunHost.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__